module.exports = __webpack_public_path__ + "img/营收.c4d315c8.png";